import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GuidePanel } from "../components/guide/GuideSystem";
import * as Legacy from "../app/runtime";

const { http, getErr, C, CSS, BrandLogo, Btn, Input, Card } = Legacy;

export const AcceptInvitationPage = () => {
  const nav = useNavigate();
  const token = useMemo(() => new URLSearchParams(window.location.search).get("token") || "", []);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: C.bg, padding: 20 }}>
      <style>{CSS}</style>
      <Card style={{ width: "100%", maxWidth: 480, borderRadius: 28, padding: 30, boxShadow: "0 26px 70px rgba(122,78,58,0.14)" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 18 }}><BrandLogo size={72} compact /></div>
        <GuidePanel pageKey="accept-invitation" compact />
        <h1 style={{ margin: "0 0 8px", fontSize: 24, fontWeight: 900, color: C.text }}>Accept Staff Invitation</h1>
        <p style={{ margin: "0 0 22px", fontSize: 13, lineHeight: 1.65, color: C.mid }}>Set your own password. This one-time invitation is linked to your individual staff account and audit trail.</p>
        {err && <div style={{ background: "#FDEAEA", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: C.danger }}>{err}</div>}
        {done ? (
          <div>
            <div style={{ background: "#EAF8F1", borderRadius: 12, padding: 14, marginBottom: 16, fontSize: 13, color: C.success }}>Password set. You can now sign in with your email.</div>
            <Btn full onClick={() => nav("/login", { replace: true })}>Go to Login</Btn>
          </div>
        ) : (
          <form onSubmit={async (event) => {
            event.preventDefault();
            if (!token) { setErr("Invitation token is missing."); return; }
            setErr("");
            setLoading(true);
            try {
              await http.post("/auth/accept-invitation", { token, password, confirmPassword });
              setDone(true);
            } catch (e: any) {
              setErr(getErr(e));
            } finally {
              setLoading(false);
            }
          }}>
            <Input label="New Password" value={password} onChange={setPassword} type="password" required />
            <Input label="Confirm Password" value={confirmPassword} onChange={setConfirmPassword} type="password" required />
            <div style={{ background: C.soft, borderRadius: 12, padding: "10px 14px", marginBottom: 16, fontSize: 12, color: C.primary, lineHeight: 1.5 }}>Invitations expire, are single-use, and are replaced when an admin resends one.</div>
            <Btn full loading={loading}>Set Password</Btn>
          </form>
        )}
      </Card>
    </div>
  );
};

export default AcceptInvitationPage;
